import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import {
  Link,
  finalEventsData,
  fetchMarketingVenuesForCollection,
  Loader,
} from '@resy/ui-kitchen';
import Cookies from '../../../../../ui-kitchen/src/providers/Cookies';
import AmexGDAHeader from './AmexGDAHeader';
import AmexGDAHero from './AmexGDAHero';
import AmexGDAOffers from './AmexGDAOffers/AmexGDAOffers';
import AmexGDAFeatured from './AmexGDAFeatured';
import AmexGDAEditorial from './AmexGDAEditorial';
import AmexGDAFooter from './AmexGDAFooter';
import AmexGDAReferFriend from './AmexGDAReferFriend';
import AmexGDAVenues from './AmexGDAVenues';
import AmexGDAChef from './AmexGDAChef';
import CustomImage from './CustomImage';
import './AmexGDA.scss';
import AmexGDALearnMore from './AmexGDALearnMore';
import AmexEventsComponent from '../AmexMarketingUtils/AmexEventsComponent';
import AmexFAQs from '../AmexMarketingUtils/AmexFAQs';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import { fetchJSONExperientialEvents, updateParsedEventData, fetchEventsAndExperientialExt } from '../AmexMarketingUtils/AmexExperientialUtils';
import { getResyLocationsThunk, getResyLocationsByCodeThunk } from '../../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { selectIsGlobalDiningAccess, selectIsGoldCardMember } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { getAmexOffers } from '../../../../../ui-kitchen/src/api/api';
import { setGDAEventsHideStatus, setResyCreditCardTypes } from '../../../../../ui-kitchen/src/reducers/amexEventsSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import {
  validateAmexData,
  validateDeltaHiltonData,
  fetchOffersResyData,
} from './AmexGDAOffers/AmexGDAOffersDetails';
import { setFunctionalCookie } from '../../../../../ui-kitchen/src/utils/resyUCMCookieUtils';
import { AMEX_GDA_PAGE } from '../../../../../ui-kitchen/src/constants/amexConstants';
import { GDA_PAGE_NAME, CTA_EVENT_NAME } from '../AmexMarketingUtils/constants';
import {
  identifyPageNameWithUrl,
  handleMktAnalytics,
  handle404Redirect,
  scrollTo,
  getIsFAQsHidden,
} from '../AmexMarketingUtils/AmexUtils';

import {
  GDA_ELIGIBLE,
  GDA_MEMBER,
  GDA_COOKIE_NAME,
  GDA_TYPE_ID,
  FEATURED,
  BOTH,
  VENUE_LIMIT,
  PLATINUM_CODE,
  PLATINUM_CARD,
  PLATINUM_CARD_ID,
} from './constants';
import { sanitizeString } from '../../../../../ui-kitchen/src/utils/sanitizeString';

const ANIMATION_STATE = {
  TO_PLAY: 'to_play',
  PLAYED: 'played',
  NEVER_PLAY: 'never_play',
};

// used to cleanup ucm cookie listener
let GDACookieCleanup = () => {};

let hashTimeout = null;
let scrollDocTimeout = null;

class AmexGDA extends React.Component {
  static propTypes = {
    $location: PropTypes.shape({
      path: PropTypes.func.isRequired,
      host: PropTypes.func.isRequired,
      search: PropTypes.func.isRequired,
    }).isRequired,
    $rootScope: PropTypes.shape({
      $digest: PropTypes.func.isRequired,
      metadata: PropTypes.string.isRequired,
    }).isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
      gdaEditorialApi: PropTypes.string.isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({
      event: PropTypes.func,
      marketingCustomPage: PropTypes.func,
    }).isRequired,
    userLanguage: PropTypes.string,
    onLogin: PropTypes.func.isRequired,
    loadNotifyModal: PropTypes.func.isRequired,
    showSeeMore: PropTypes.bool,
    collections: PropTypes.arrayOf(PropTypes.object),
    Config: PropTypes.shape({
      origin: PropTypes.string.isRequired,
    }).isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      ipadLandscape: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    venues: PropTypes.shape(PropTypes.object),
    isUserLoggedInAsGDA: PropTypes.bool.isRequired,
    selectedCoreSeats: PropTypes.number.isRequired,
    selectedCoreISODate: PropTypes.string.isRequired,
    selectedCoreTime: PropTypes.string.isRequired,
    locationBySlug: PropTypes.shape({}).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    userLocation: PropTypes.shape({
      isNonUS: PropTypes.bool,
    }).isRequired,
  };

  static defaultProps = {
    userLanguage: navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage),
    showSeeMore: true,
    collections: [],
    venues: {},
  }

  sectionLearn = React.createRef();

  state = {
    featuredRestaurantsList: [],
    blogDataArray: [],
    hash: null,
    prefersReducedMotion: false,
    learnDivFocus: false,
    animationPlay: ANIMATION_STATE.TO_PLAY,
    animationPlayed: false,
    chefData: {},
    dataOutput: null,
    gdaCookie: '',
    collection: {},
    gdaVenuesShow: false,
    venues: [],
    ignoreNextScrollEvent: false, // flag to tell if the scroll was programmatic or by the user
    hasOriginB2B: false,
    // Offers
    isHidePlatOffer: true,
    offersResyData: null,
    isOffersLoading: false,
    errorMsgArrayState: [],
    gdaHiltonDeltaCardOrder: '',
    eventsLoading: true,
    eventComponentStatus: true,
    scrollTimeout: 1000,
    userBrowserLang: 'en-US',
    showNaa2025: false,
    // data callback flags
    isVenueDataLoaded: false,
    isOffersDataLoaded: false,
    isFeaturedDataLoaded: false,
    isEventsDataLoaded: false,
    hideFAQs: false,
  };

  componentDidMount() {
    const currentHash = (window.location.hash).replace('#', '');
    this.hashSetup();
    this.fetchFeaturedData(currentHash);
    this.fetchDataWithConfig();
    this.prefersReducedMotion();
    this.handleOriginB2B();

    window.addEventListener('scroll', this.onScrollToElement);
    const { referrer } = window.document;
    const encodedReferrer = encodeURIComponent(referrer);
    this.setState({ referrerValue: encodedReferrer });
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      hash,
      dataOutput,
      eventComponentStatus,
      scrollTimeout,
      isVenueDataLoaded,
      isOffersDataLoaded,
      isFeaturedDataLoaded,
      isEventsDataLoaded,
      isAllCallsCompleted,
    } = this.state;
    const {
      venues,
      isUserLoggedInAsGDA,
      selectedCoreSeats,
      selectedCoreISODate,
      selectedCoreTime,
      locationBySlug = {},
      dispatch,
      collections,
    } = this.props;

    if (prevState.hash !== hash && hash !== '') {
      window.location.hash = `#${hash}`;
    }

    if (prevState.isVenueDataLoaded !== isVenueDataLoaded
      || prevState.isOffersDataLoaded !== isOffersDataLoaded
      || prevState.isFeaturedDataLoaded !== isFeaturedDataLoaded
      || prevState.isEventsDataLoaded !== isEventsDataLoaded) {
      this.setAllCallsCompleted(isVenueDataLoaded, isOffersDataLoaded, isFeaturedDataLoaded, isEventsDataLoaded);
    }

    if (prevState.isAllCallsCompleted !== isAllCallsCompleted) {
      if (isAllCallsCompleted && hash !== '') {
        hashTimeout = setTimeout(() => this.handleHashScrollOnLoad(hash), scrollTimeout);
      }
    }

    if (venues && venues !== prevProps.venues) {
      this.fetchVenues();
    }

    if (prevProps.collections !== collections) {
      this.fetchVenues();
    }

    if (prevProps.isUserLoggedInAsGDA !== isUserLoggedInAsGDA) {
      this.setGDAPageCookie();
    }

    if (Object.keys(locationBySlug).length > 0
      && (prevProps.selectedCoreSeats !== selectedCoreSeats
        || prevProps.selectedCoreISODate !== selectedCoreISODate
        || prevProps.selectedCoreTime !== selectedCoreTime
        || prevProps.locationBySlug !== locationBySlug
        || prevState.dataOutput !== dataOutput)) {
      if (!dataOutput?.events_and_experiences?.hide_section) {
        const eventsFetchedData = await fetchEventsAndExperientialExt(this.props, dataOutput?.events_and_experiences, GDA_PAGE_NAME);
        this.updateEventsState(eventsFetchedData);
      }
    }

    if (eventComponentStatus !== prevState.eventComponentStatus || prevState.dataOutput !== dataOutput) {
      const hideEvents = dataOutput?.events_and_experiences?.hide_section || !eventComponentStatus;
      dispatch(setGDAEventsHideStatus(hideEvents));
      this.componentCallback('isEventsDataLoaded', true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollToElement);
    window.removeEventListener('hashchange', this.handleHashChange);
    GDACookieCleanup();
    if (hashTimeout) clearTimeout(hashTimeout);
    if (scrollDocTimeout) clearTimeout(scrollDocTimeout);
  }

  setGDAPageCookie() {
    const { isUserLoggedInAsGDA } = this.props;
    let gdaCookie = '';
    if (isUserLoggedInAsGDA) {
      const expires = moment().add(365, 'days').toDate();
      GDACookieCleanup = setFunctionalCookie(GDA_COOKIE_NAME, GDA_MEMBER, { expires });
      gdaCookie = GDA_MEMBER;
    } else {
      gdaCookie = Cookies.get(GDA_COOKIE_NAME);
    }
    this.setState({ gdaCookie });
    return gdaCookie;
  }

  updateEventsState = (eventsFetchedData) => {
    this.setState({ eventsFetchedData, eventsLoading: false });
  }

  login = () => {
    const { onLogin } = this.props;
    onLogin();
  }

  isScrolledIntoView = (el) => {
    const rect = el.current.getBoundingClientRect();
    let isVisible = false;
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
  }

  onScrollToElement = () => {
    const { ignoreNextScrollEvent, hash } = this.state;

    if (!window.location.hash || (hash && ignoreNextScrollEvent)) {
      const { prefersReducedMotion, learnDivFocus, animationPlay } = this.state;
      const isVisible = (this.sectionLearn?.current) ? this.isScrolledIntoView(this.sectionLearn) : false;
      if (!prefersReducedMotion) {
        if (isVisible && !learnDivFocus) {
          this.sectionLearn.current.focus();
          this.setState({ learnDivFocus: true, animationPlay: ANIMATION_STATE.PLAYED });
        } else if (animationPlay === ANIMATION_STATE.PLAYED) {
          this.setState({ animationPlay: ANIMATION_STATE.NEVER_PLAY, animationPlayed: true });
          this.sectionLearn.current.blur();
        }
      } else {
        this.setState({ animationPlay: ANIMATION_STATE.NEVER_PLAY, animationPlayed: true });
      }
    }
  }

  hashSetup = () => {
    // clearing out the hash so that the browser doesnt anchor on mount
    window.location.hash = '';
    window.addEventListener('hashchange', this.handleHashChange);
  }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');

    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  }

  handleHashScrollOnLoad = (hash) => {
    this.setAnimationPlayed();
    scrollDocTimeout = setTimeout(() => scrollTo(hash), 500);
    this.setState({ ignoreNextScrollEvent: false });
  }

  setScrollForDirMenu = async (link) => {
    const hash = link.replace('#', '');
    this.setState({ hash });
    await this.setAnimationPlayed();
    scrollTo(link);
    await this.setState({ ignoreNextScrollEvent: false });
  }

  handleMixpanelCall = (eventName) => {
    const { Analytics } = this.props;
    const params = {
      category: 'Resy Global Dining Access Interaction',
      context: 'Resy Global Dining Access',
    };
    Analytics.marketingCustomPage([eventName, params]);
  }

  handleAddCard = () => {
    const { Analytics: { event } } = this.props;
    const extraParams = {
      // eslint-disable-next-line camelcase
      action_name: 'Unlock Your Benefits - Add your card Click',
    };
    handleMktAnalytics(event, CTA_EVENT_NAME, extraParams);
  }

  handleOriginB2B = () => {
    const { $location } = this.props;
    const { origin } = $location.search();
    if (origin && origin === 'B2BPartner') this.setState({ hasOriginB2B: true });
  };

  fetchDataFile = async (gdaLanguagesPermitted) => {
    const {
      userLanguage,
      ResyAmexConfig: {
        baseRequestUrl,
      },
      dispatch,
    } = this.props;

    let dataOutput;
    let hideFAQs;
    const langArr = gdaLanguagesPermitted.split(',');

    const match = langArr.find((element) => {
      if (element === userLanguage) {
        return true;
      }
      return false;
    });

    const userBrowserLang = match ? userLanguage : 'en-US';
    const fileName = `GDA_${userBrowserLang}.json`;

    const gdaDataEndPoint = `${baseRequestUrl}GDA/${fileName}`;
    try {
      const dataResponse = await fetch(gdaDataEndPoint, {
        method: 'GET',
      });
      dataOutput = await dataResponse.json();
      hideFAQs = getIsFAQsHidden(dataOutput?.faqs);
    } catch (err) {
      Logger.error('[AmexGDA] GDA JSON File Error:', err);
    }
    this.setState({ dataOutput, userBrowserLang, hideFAQs });
    const {
      hideNAASection = false,
      amex_card_types: amexCardTypes,
    } = dataOutput;
    this.checkDisplayGDAAcquisition(hideNAASection);
    dispatch(setResyCreditCardTypes(amexCardTypes));
    return dataOutput;
  }

  fetchConfig = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    let configData;
    const gdaConfigEndPoint = `${baseRequestUrl}GDA/GDAConfig.json`;
    try {
      const configResponse = await fetch(gdaConfigEndPoint, {
        method: 'GET',
      });
      configData = await configResponse.json();
    } catch (err) {
      Logger.error('[AmexGDA] GDA Config JSON File Error:', err);
    }
    return configData;
  }

  fetchBlogData = async () => {
    const {
      ResyAmexConfig: {
        gdaEditorialApi,
      },
    } = this.props;

    let blogDataArray = [];
    const blogURL = `${gdaEditorialApi}posts/?categories=15376`;
    try {
      const blogResponse = await fetch(blogURL, {
        method: 'GET',
      });
      blogDataArray = await blogResponse.json();
    } catch (err) {
      Logger.error('[AmexGDA] Error:', err);
    }
    return blogDataArray;
  }

  fetchDataWithConfig = async () => {
    const configPromise = this.fetchConfig();

    configPromise.then((configResponse) => {
      if (configResponse) {
        /* eslint camelcase: ["error", {ignoreDestructuring: true}] */
        // eslint-disable-next-line camelcase
        const {
          // eslint-disable-next-line camelcase
          is_page_enabled = true,
          // eslint-disable-next-line camelcase
          gda_chefs_show = true,
          // eslint-disable-next-line camelcase
          gda_venues_show = true,
          // eslint-disable-next-line camelcase
          gda_editorials_maxcount = -1,
          // eslint-disable-next-line camelcase
          gda_editorials_show = true,
          // eslint-disable-next-line camelcase
          gda_events_maxcount = -1,
          // eslint-disable-next-line camelcase
          gda_events_show = true,
          // eslint-disable-next-line camelcase
          gda_languages_permitted = 'en-US',
          scroll_timeout: scrollTimeout,
          // eslint-disable-next-line camelcase
          show_naa2025 = false,
        } = configResponse;

        // eslint-disable-next-line camelcase
        if (!is_page_enabled) {
          handle404Redirect();
        }
        // eslint-disable-next-line camelcase
        if (gda_chefs_show) {
          this.fetchChefData(gda_languages_permitted);
        }
        // eslint-disable-next-line camelcase
        if (gda_venues_show) {
          // eslint-disable-next-line camelcase
          this.setState({ gdaVenuesShow: gda_venues_show });
          this.fetchVenues();
        }
        // eslint-disable-next-line camelcase
        if (gda_editorials_show) {
          this.getBlogData(gda_editorials_maxcount);
        }
        // eslint-disable-next-line camelcase
        if (gda_events_show) {
          this.fetchEventsData(gda_events_maxcount);
        }
        // eslint-disable-next-line camelcase
        if (show_naa2025) this.setState({ showNaa2025: show_naa2025 });

        // eslint-disable-next-line camelcase
        if (gda_languages_permitted) {
          this.fetchDataFile(gda_languages_permitted);
        }

        if (scrollTimeout) this.setState({ scrollTimeout: parseInt(scrollTimeout, 10) });
      }
    });
  }

  getBlogData = async (gdaEditorialsMaxCount) => {
    const blogArrayResponse = await this.fetchBlogData();

    if (blogArrayResponse && Array.isArray(blogArrayResponse)) {
      let updatedResponse = null;
      if (gdaEditorialsMaxCount !== -1 && (blogArrayResponse?.length > gdaEditorialsMaxCount)) {
        updatedResponse = blogArrayResponse.slice(0, gdaEditorialsMaxCount);
      } else {
        updatedResponse = blogArrayResponse;
      }
      const finalResponse = updatedResponse.map((item, indexItem) => {
        const newItem = { ...item, position: indexItem };
        return newItem;
      });
      this.setState({ blogDataArray: finalResponse });
    }
  }

  fetchEventsData = async (gdaEventsmaxCount) => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      dispatch,
    } = this.props;
    dispatch(finalEventsData(baseRequestUrl, gdaEventsmaxCount));
  }

  fetchFeaturedData = async (hash) => {
    const {
      userLanguage,
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    // fetch featured venues

    const assetsEndpoint = `${baseRequestUrl}FeaturedVenues/GDAFeaturedVenues.json`;
    try {
      const response = await fetch(assetsEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': baseRequestUrl,
        },
        mode: 'cors',
      });
      const featuredData = await response.json();
      const selectedList = userLanguage === 'en-GB' ? featuredData.featuredUK.restaurants : featuredData.featuredUS.restaurants;
      // images are stored in S3 now. Use baseRequestUrl in the image path
      const featuredRestaurantsList = selectedList
        .filter((venue) => (venue.venue_type === BOTH || venue.venue_type === FEATURED))
        .map((venue) => ({
        // eslint-disable-next-line camelcase
          city_name: venue.city_name,
          cuisine: venue.cuisine,
          currency: venue.currency,
          image: `${baseRequestUrl}FeaturedVenues/${venue.image}`,
          name: venue.name,
          // eslint-disable-next-line camelcase
          price_range: venue.price_range,
          bookNowLink: venue.bookNowLink || '',
          // eslint-disable-next-line camelcase
          venue_url: venue.venue_url || '',
          // eslint-disable-next-line camelcase
          venue_url_text: venue.venue_url_text || '',
          id: venue.id,
        }));
      const featuredRestaurantsListOrdered = featuredRestaurantsList.sort((a, b) => a.id - b.id);
      this.setState({ featuredRestaurantsList: featuredRestaurantsListOrdered, hash, isFeaturedDataLoaded: true });
    } catch (err) {
      // error handling
      this.setState({ featuredRestaurantsList: [], hash, isFeaturedDataLoaded: true });
    }
  }

  fetchChefData = async (gdaLanguagesPermitted) => {
    const {
      userLanguage,
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    const assetsEndpoint = `${baseRequestUrl}GDAChef/GDAChefData.json`;
    try {
      const response = await fetch(assetsEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': baseRequestUrl,
        },
        mode: 'cors',
      });
      const data = await response.json();
      const langArr = gdaLanguagesPermitted.split(',');
      const langMatch = langArr.find((element) => element === userLanguage) || 'en-US';

      const chefData = data[langMatch] || {};
      this.setState({ chefData });
    } catch (err) {
      Logger.error(err);
      this.setState({ chefData: {} });
    }
  }

  parseCollections = () => {
    const {
      collections,
    } = this.props;

    const collection = collections.filter((val) => val.info.type_id === GDA_TYPE_ID);
    return collection?.[0] || {};
  }

  fetchVenues = async () => {
    const {
      venues,
      dispatch,
    } = this.props;

    const collection = this.parseCollections();
    const { id: collectionId } = collection;

    let locationCode;
    let locationName;
    let locationSlug;
    let venuesFromState;

    const { $location } = this.props;
    const { city } = $location.search();

    if (ENV !== 'prod' && city && city !== '') {
      const key = `${city}-${collectionId}-${VENUE_LIMIT}}`;
      venuesFromState = venues[key];
      locationCode = city;
      const locationData = await dispatch(getResyLocationsByCodeThunk(locationCode));
      locationName = locationData?.name || 'New York';
      locationSlug = locationData?.url_slug;
    } else {
      locationCode = await dispatch(getResyLocationsThunk('rgaCityCode')) || 'ny';
      locationName = await dispatch(getResyLocationsThunk('rgaCityName')) || 'New York';
      const locationData = await dispatch(getResyLocationsByCodeThunk(locationCode));
      locationSlug = locationData?.url_slug;
      const key = `${locationCode}-${collectionId}-${VENUE_LIMIT}`;
      venuesFromState = venues[key];
    }

    moment.tz.setDefault('America/New_York');
    const now = moment();
    const selectedDate = now.format('YYYY-MM-DD');

    this.setState({
      locationCode,
      locationSlug,
      selectedDate,
      selectedSeats: 2,
      locationName,
      venues: venuesFromState || [],
      collection,
      isVenueDataLoaded: true,
    });

    if (venuesFromState || !collectionId) return;

    /* eslint-disable camelcase */
    const payload = {
      location_id: locationCode,
      collection_id: collectionId,
      day: moment().format('YYYY-MM-DD'),
      party_size: 2,
      finder: 4,
      offset: 1,
      limit: VENUE_LIMIT,
    };
    /* eslint-enable camelcase */

    const key = `${locationCode}-${collectionId}-${VENUE_LIMIT}`;
    if (!venues[key]) {
      try {
        await dispatch(fetchMarketingVenuesForCollection(payload));
      } catch (error) {
        Logger.error('[AmexGda] Get Marketing Venues Error:', error);
      }
    }
  }

  checkDisplayGDAAcquisition = (hideNAASection) => {
    const {
      $location, $rootScope: {
        metadata,
      },
    } = this.props;

    const gdaCookie = this.setGDAPageCookie();
    let isHidePlatOffer = false;
    const { userLocation } = this.props;
    let isNonUSLocation = false;
    if (userLocation) {
      isNonUSLocation = userLocation.isNonUS;
    }

    if (gdaCookie === GDA_ELIGIBLE || gdaCookie === GDA_MEMBER || isNonUSLocation || hideNAASection
              || (AMEX_GDA_PAGE === identifyPageNameWithUrl($location, metadata))) {
      isHidePlatOffer = true;
    }

    if (!isHidePlatOffer) {
      this.getGDAOffersData();
    } else this.setState({ isOffersDataLoaded: true });
    this.setState({ isHidePlatOffer });
  }

  getGDAOffersData = async () => {
    const errorArray = [];
    this.setState({ isOffersLoading: true });
    const {
      $location,
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const { testing } = $location.search();

    // Fetch S3 Resy Data JSON file
    const offersResyData = await fetchOffersResyData(baseRequestUrl, errorArray);

    if (errorArray && errorArray.length > 0) {
      const { errorMsgArrayState } = this.state;
      this.setState({
        errorMsgArrayState: [
          ...errorMsgArrayState,
          ...errorArray,
        ],
      });
      this.printConsoleError('fetchOffersResyData');
      return;
    }

    if (offersResyData !== null) {
      // Fetch S3 equivalent of Offers API data
      if (testing === 'true' && ENV !== 'prod') {
        const { offers_api_amex_response: offersAPIAmexResponseUrl } = offersResyData;
        this.fetchAndProcessAmexData(offersResyData, offersAPIAmexResponseUrl);
      } else {
        // Fetch Offers API data
        this.fetchAndProcessAmexData(offersResyData);
      }
    }
  };

  printConsoleError = () => {
    const { errorMsgArrayState } = this.state;
    if (errorMsgArrayState.length > 0) {
      Logger.error(errorMsgArrayState);
    }
    this.setState({ isOffersLoading: false });
  };

  fetchOffersResyAmexData = async (offersAPIAmexResponseUrl, eep) => {
    const errorArray = [];
    const {
      $location,
      Config: {
        origin,
      },
    } = this.props;

    const { testing } = $location.search();

    let offersResyAmexData = null;
    try {
      if (testing === 'true' && ENV !== 'prod') {
        const apiResponse = await fetch(offersAPIAmexResponseUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Origin': origin,
          },
          mode: 'cors',
        });
        offersResyAmexData = await apiResponse.json();
      } else {
        const payload = { ...(eep ? { eep } : {}) };
        offersResyAmexData = await getAmexOffers(payload);
      }
      return offersResyAmexData;
    } catch (error) {
      Logger.error('[AmexGDAOffers] fetchOffersResyAmexData() failure: ', error?.data?.message);
      if (error?.status >= 400) {
        if (error?.data?.code === 'invalid_eep_error') errorArray.push(`[AmexGDAOffers] RESY API Response Error: ${error?.data?.code}`);
        if (error?.data?.message === 'Not a valid integer.') errorArray.push('[AmexGDAOffers] RESY API Response Error: eep is not a valid integer.');
        else if (error?.data?.message) errorArray.push(`[AmexGDAOffers] RESY API Response Error: ${error?.data?.message}`);
        this.handleMixpanelCall('GDA INVALID EEP');
      } else {
        errorArray.push(`[AmexGDAOffers] RESY API Response Error: ${error?.data?.message}`);
      }
      const { errorMsgArrayState } = this.state;
      this.setState({
        errorMsgArrayState: [
          ...errorMsgArrayState,
          ...errorArray,
        ],
      });
      this.printConsoleError('fetchOffersResyAmexData');
    }
    return null;
  };

  fetchAndProcessAmexData = async (offersResyData, offersAPIAmexResponseUrl) => {
    const errorArray = [];
    const {
      api_products: products,
      all_card_product_order_desktop: allCardProductOrderDesktop,
      all_card_product_order_mobile: allCardProductOrderMobile,
      additional_products: additionalProducts,
    } = offersResyData;
    const platProduct = products && products.find((product) => product.product_code === PLATINUM_CODE);
    const eepValue = platProduct.eep_value;
    const offersAmexData = await this.fetchOffersResyAmexData(offersAPIAmexResponseUrl, eepValue);

    if (!offersAmexData?.offers) {
      errorArray.push('[AmexGDAOffers] Amex API Offers array is null or undefined, Please fix and proceed');
    } else {
      const { offers } = offersAmexData;
      validateAmexData(offers, PLATINUM_CODE, PLATINUM_CARD, errorArray, products);
      const { matchMedia } = this.props;
      const isDesktopMedia = !!(matchMedia.lg);
      let gdaHiltonDeltaCardOrder = '';
      if (isDesktopMedia) {
        if (allCardProductOrderDesktop?.indexOf(PLATINUM_CARD_ID) === -1) {
          errorArray.push('[AmexGDAOffers] PLATINUM_CARD_ID is not existing in all_card_product_order_desktop S3 gda_offers_resy_data json, Please fix and proceed');
        }
        gdaHiltonDeltaCardOrder = validateDeltaHiltonData(additionalProducts, allCardProductOrderDesktop, errorArray);
        this.setState({ gdaHiltonDeltaCardOrder });
      } else {
        if (allCardProductOrderMobile?.indexOf(PLATINUM_CARD_ID) === -1) {
          errorArray.push('[AmexGDAOffers] PLATINUM_CARD_ID is not existing in all_card_product_order_mobile S3 gda_offers_resy_data json, Please fix and proceed');
        }
        gdaHiltonDeltaCardOrder = validateDeltaHiltonData(additionalProducts, allCardProductOrderMobile, errorArray);
        this.setState({ gdaHiltonDeltaCardOrder });
      }

      const { errorMsgArrayState } = this.state;
      const errorData = [
        ...errorMsgArrayState,
        ...errorArray,
      ];

      if (errorData?.length === 0) {
        this.setState({
          isOffersLoading: false,
          offersResyData,
          offersResyPlatAmexData:
             offers?.find((offer) => offer.product_code === PLATINUM_CODE),
          isOffersDataLoaded: true,
        });
      }

      this.setState({
        errorMsgArrayState: errorData,
      });
      this.printConsoleError('getOffersPageData');
    }
  };

  updateEventsDataForNotify = async (eventDetails) => {
    const {
      eventsFetchedData,
    } = this.state;

    const {
      experientialEvents,
      experientialEventsConfig,
    } = eventsFetchedData;
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug,
    } = this.props;

    const propsValue = {
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug,
    };

    const jsonExperientialEvents = await fetchJSONExperientialEvents(baseRequestUrl);

    this.setState({
      eventsFetchedData: {
        ...eventsFetchedData,
        experientialEvents: updateParsedEventData(
          eventDetails,
          experientialEvents,
          experientialEventsConfig,
          jsonExperientialEvents,
          propsValue
        ),
      },
    });
  }

  handleShowAll = () => {
    const { $location } = this.props;
    const { showall = '' } = $location.search();
    return showall === 'enabled';
  }

  getComponentStatus = (compName, status) => {
    this.setState({
      [compName]: status,
    });
  }

  setAnimationPlayed = () => this.setState({
    animationPlay: ANIMATION_STATE.NEVER_PLAY,
    animationPlayed: true,
    ignoreNextScrollEvent: true,
  });

  componentCallback = (componentStateName, stateValue) => {
    const { scrollTimeout } = this.state;
    this.setState({ [componentStateName]: stateValue });
    if (componentStateName === 'hash') {
      hashTimeout = setTimeout(() => this.handleHashScrollOnLoad(stateValue), scrollTimeout);
    }
  }

  setAllCallsCompleted = (isVenueDataLoaded, isOffersDataLoaded, isFeaturedDataLoaded, isEventsDataLoaded) => {
    const isLoaded = isVenueDataLoaded && isOffersDataLoaded && isFeaturedDataLoaded && isEventsDataLoaded;
    this.setState({ isAllCallsCompleted: isLoaded });
  }

  prefersReducedMotion() {
    /* If the users OS supports reduced motion and the user has set it to true, remove the autoplay attribute from the video and pause it */
    if (window.matchMedia('(prefers-reduced-motion)').matches) {
      this.setState({ prefersReducedMotion: true, animationPlay: ANIMATION_STATE.NEVER_PLAY });
    }
  }

  render() {
    const {
      ResyAmexConfig: {
        gdaEditorialApi,
        baseRequestUrl,
      },
      Analytics,
      $rootScope,
      showSeeMore,
      loadNotifyModal,
      matchMedia,
      isUserLoggedInAsGDA,
      isAuthenticated,
      selectedCoreSeats,
      dispatch,
      userLocation,
      $location, $rootScope: {
        metadata,
      },
    } = this.props;
    const {
      featuredRestaurantsList,
      blogDataArray,
      chefData,
      dataOutput,
      gdaCookie,
      venues,
      collection,
      locationCode,
      locationSlug,
      selectedDate,
      selectedSeats,
      gdaVenuesShow,
      locationName,
      animationPlay,
      animationPlayed,
      hasOriginB2B,
      // Added for Offers section
      isHidePlatOffer,
      errorMsgArrayState,
      offersResyPlatAmexData,
      offersResyData,
      isOffersLoading,
      referrerValue,
      gdaHiltonDeltaCardOrder,
      eventsFetchedData,
      eventsLoading,
      eventComponentStatus,
      hash,
      userBrowserLang,
      showNaa2025,
      hideFAQs,
    } = this.state;

    const pageContentByLanguage = dataOutput;

    const hideEvents = dataOutput?.events_and_experiences?.hide_section || !eventComponentStatus;
    const isEditorialExists = blogDataArray?.length > 0;

    const printContent = (text, key, isHTML) => {
      const errorText = `ERROR ${key}`;
      if ((!text || text === '') && isHTML) {
        return `<i class="errorText">${errorText}</i>`;
      } if (!text || text === '') {
        return (<i className="errorText">{errorText}</i>);
      } if (text && Array.isArray(text) && text?.length === 0) {
        return (<i className="errorText">{errorText}</i>);
      }
      return text;
    };

    const isHidePlatOfferSection = isOffersLoading || isHidePlatOffer || errorMsgArrayState?.length > 0;

    let isShowReferAFriend = false;
    let isGdaMember = false;
    let isGdaEligible = false;
    let isNonUSLocation = false;
    if (userLocation) {
      isNonUSLocation = userLocation.isNonUS;
    }

    if ((gdaCookie === GDA_ELIGIBLE || gdaCookie === GDA_MEMBER
      || (AMEX_GDA_PAGE === identifyPageNameWithUrl($location, metadata))) && !isNonUSLocation) {
      isShowReferAFriend = true;
    }

    if (gdaCookie === GDA_MEMBER) {
      isGdaMember = true;
    }

    if (gdaCookie === GDA_ELIGIBLE) {
      isGdaEligible = true;
    }
    const isHideUnlockBenefits = isGdaMember;

    const eventsAndExperiencesData = {
      ...eventsFetchedData,
      eventsLoading,
      isAuthenticated,
      $rootScope,
      selectedCoreSeats,
      updateParsedEventData: this.updateEventsDataForNotify,
      showAllEnabled: this.handleShowAll(),
    };

    // if featured restaurants list is empty, hide the link
    if (pageContentByLanguage) {
      const menuList = () => {
        if (featuredRestaurantsList?.length === 0 && pageContentByLanguage.menuItems) {
          return pageContentByLanguage.menuItems.filter((item) => item.id !== 3);
        }
        return pageContentByLanguage.menuItems;
      };

      const {
        heroHeadline,
        heroBlurb,
        heroMessage,
        heroImg,
        heroImgAlt,
        heroHeadlineNonGda,
        heroBlurbNonGda,
        heroMessageNonGdaQuestion,
        heroMessageNonGdaLinkText,
        heroMessageNonGdaMessage,
        headerTextImg,
        heroMessageNonGdaCta,
        heroMessageNonGdaCtaHref,
        heroMessageNonGdaLinkHref,
      } = pageContentByLanguage;

      const heroData = {
        heroHeadline,
        heroBlurb,
        heroMessage,
        heroImg,
        heroImgAlt,
        heroHeadlineNonGda,
        heroBlurbNonGda,
        heroMessageNonGdaQuestion,
        heroMessageNonGdaLinkText,
        heroMessageNonGdaMessage,
        headerTextImg,
        heroMessageNonGdaCta,
        heroMessageNonGdaCtaHref,
        heroMessageNonGdaLinkHref,
      };
      const showVenues = gdaVenuesShow && Object.keys(collection)?.length > 0 && venues?.length > 0 && isGdaMember;

      const {
        learnHeadline, learnBlurb, learn1Headline, learn1Paragraph1, learn1Paragraph2,
        learn2Headline, learn2Paragraph1, learnMoreImage,
      } = pageContentByLanguage;

      const pageContentByLanguageLearnMore = {
        learnHeadline,
        learnBlurb,
        learn1Headline,
        learn1Paragraph1,
        learn1Paragraph2,
        learn2Headline,
        learn2Paragraph1,
        learnMoreImage,
      };

      const sanitizedJoinStep1 = sanitizeString(pageContentByLanguage.joinStep1);
      const sanitizedJoinStep2 = sanitizeString(pageContentByLanguage.joinStep2);
      const sanitizedJoinStep3 = sanitizeString(pageContentByLanguage.joinStep3);
      const sanitizedJoinStep4 = sanitizeString(pageContentByLanguage.joinStep4);
      return (
        <div className="GDA container">
          <AmexGDAHeader
            setScrollForDirMenu={this.setScrollForDirMenu}
            menuItems={menuList()}
            mobileMenuContent={pageContentByLanguage.mobileMenuContent}
            headerTextImg={pageContentByLanguage.headerTextImg}
            baseRequestUrl={baseRequestUrl}
            amexFooterImg={pageContentByLanguage.amexFooterImg}
            printContent={printContent}
            isGdaMember={isGdaMember}
            isGdaEligible={isGdaEligible}
            isUSLocation={!isNonUSLocation}
            hideEvents={hideEvents}
            isEditorialExists={isEditorialExists}
            hasOriginB2B={hasOriginB2B}
            Analytics={Analytics}
            hideFAQs={hideFAQs}
            componentCallback={this.componentCallback}
          />
          <div>
            <AmexGDAHero
              baseRequestUrl={baseRequestUrl}
              printContent={printContent}
              isGdaMember={isGdaMember}
              login={this.login}
              heroData={heroData}
              Analytics={Analytics}
              setScrollForDirMenu={this.setScrollForDirMenu}
            />
            <section className="GDA__section" id="benefits">
              <div className="GDA__Benefits">
                <h2>{printContent(pageContentByLanguage.benefitsHeadline, 'benefitsHeadline')}</h2>
                <div className="GDA__Benefits__Group">
                  <div className="GDA__Benefits__Group--card">
                    <CustomImage key={pageContentByLanguage.benefitOneImg} imageName={pageContentByLanguage.benefitOneImg} baseRequestUrl={baseRequestUrl} />
                    <h3>{printContent(pageContentByLanguage.benefits1Title, 'benefits1Title')}</h3>
                    <p>{printContent(pageContentByLanguage.benefits1Blurb, 'benefits1Blurb')}</p>
                  </div>
                  <div className="GDA__Benefits__Group--card">
                    <CustomImage key={pageContentByLanguage.benefitTwoImg} imageName={pageContentByLanguage.benefitTwoImg} baseRequestUrl={baseRequestUrl} />
                    <h3>{printContent(pageContentByLanguage.benefits2Title, 'benefits2Title')}</h3>
                    <p>{printContent(pageContentByLanguage.benefits2Blurb, 'benefits2Blurb')}</p>
                  </div>
                  <div className="GDA__Benefits__Group--card">
                    <CustomImage key={pageContentByLanguage.benefitThreeImg} imageName={pageContentByLanguage.benefitThreeImg} baseRequestUrl={baseRequestUrl} />
                    <h3>{printContent(pageContentByLanguage.benefits3Title, 'benefits3Title')}</h3>
                    <p>{printContent(pageContentByLanguage.benefits3Blurb, 'benefits3Blurb')}</p>
                  </div>
                  <div className="GDA__Benefits__Group--card">
                    <CustomImage key={pageContentByLanguage.benefitFourImg} imageName={pageContentByLanguage.benefitFourImg} baseRequestUrl={baseRequestUrl} />
                    <h3>{printContent(pageContentByLanguage.benefits4Title, 'benefits4Title')}</h3>
                    <p>{printContent(pageContentByLanguage.benefits4Blurb, 'benefits4Blurb')}</p>
                  </div>
                </div>
              </div>
            </section>
            <section className="GDA__section" id="referafriend">
              {isShowReferAFriend
              && (
              <AmexGDAReferFriend
                baseRequestUrl={baseRequestUrl}
                pageContentByLanguage={pageContentByLanguage}
                printContent={printContent}
                Analytics={Analytics}
              />
              )}
            </section>
            <section className="GDA__section" id="gdavenues">
              { showVenues && (
                <AmexGDAVenues
                  $rootScope={$rootScope}
                  userIsGda={isUserLoggedInAsGDA}
                  loadNotifyModal={loadNotifyModal}
                  restaurants={venues}
                  selectedDate={selectedDate}
                  selectedSeats={selectedSeats}
                  showSeeMore={showSeeMore}
                  locationCode={locationCode}
                  locationSlug={locationSlug}
                  collection={collection}
                  Analytics={Analytics}
                  headline={pageContentByLanguage.gdaVenuesHeadline}
                  intro={pageContentByLanguage.gdaVenuesIntro}
                  utm={pageContentByLanguage.gdaSeeMoreUtm}
                  printContent={printContent}
                  cityName={locationName}
                  matchMedia={matchMedia}
                />
              )}
            </section>
            <section className="GDA__section" id="platinumoffer">
              {isOffersLoading && (
              <div>
                <Loader className="AmexMCLP__loader" />
              </div>
              )}
              { !isHidePlatOfferSection
                && (
                  <AmexGDAOffers
                    offersResyData={offersResyData}
                    offersResyAmexData={offersResyPlatAmexData}
                    showNaa2025={showNaa2025}
                    Analytics={Analytics}
                    matchMedia={matchMedia}
                    baseRequestUrl={baseRequestUrl}
                    referrer={referrerValue}
                    gdaHiltonDeltaCardOrder={gdaHiltonDeltaCardOrder}
                  />
                )}
            </section>
            {!isHideUnlockBenefits
            && (
              <section className="GDA__section" id="unlock">
                <div className="GDA__Unlock">
                  <h2>{printContent(pageContentByLanguage.joinHeading, 'joinHeading')}</h2>
                  <p>{printContent(pageContentByLanguage.joinBlurb1, 'joinBlurb1')}</p>
                  <p className="fine-print">{printContent(pageContentByLanguage.joinBlurb2, 'joinBlurb2')}</p>
                  <ol className="GDA__Unlock__Group">
                    <li className="GDA__Unlock__Group--card">
                      {/* eslint-disable react/no-danger */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: printContent(sanitizedJoinStep1, 'joinStep1', true),
                        }}
                      />
                    </li>
                    <li className="GDA__Unlock__Group--card">
                      {/* eslint-disable react/no-danger */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: printContent(sanitizedJoinStep2, 'joinStep2', true),
                        }}
                      />
                    </li>
                    <li className="GDA__Unlock__Group--card">
                      {/* eslint-disable react/no-danger */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: printContent(sanitizedJoinStep3, 'joinStep3', true),
                        }}
                      />
                    </li>
                    <li className="GDA__Unlock__Group--card">
                      {/* eslint-disable react/no-danger */}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: printContent(sanitizedJoinStep4, 'joinStep4', true),
                        }}
                      />
                    </li>
                  </ol>
                  <div className="GDA__Unlock__Button-Container">
                    {(!pageContentByLanguage.unlockAddYourCard || pageContentByLanguage.unlockAddYourCard === '')
                    && printContent(pageContentByLanguage.unlockAddYourCard, 'unlockAddYourCard')}
                    <p>
                      <Link
                        role="link"
                        variant="no-style"
                        href={pageContentByLanguage.unlockAddYourCard}
                        className="GDA__Unlock__Button-Container__CTA"
                        onContextMenu={() => this.handleAddCard()}
                        onClick={() => this.handleAddCard()}
                        target="_self"
                      >
                        {printContent(pageContentByLanguage.joinCTA, 'joinCTA')}
                      </Link>
                      {printContent(pageContentByLanguage.joinCTACaption, 'joinCTACaption')}
                    </p>
                    <p>
                      <Link
                        variant="no-style"
                        className="GDA__Unlock__Button-Container__terms"
                        href={`${window?.location?.href?.split('#')[0]}#global-dining-access-terms`}
                        onClick={async () => {
                          await this.setScrollForDirMenu('#global-dining-access-terms');
                        }}
                      >
                        {printContent(pageContentByLanguage.joinTerms, 'joinTerms')}
                      </Link>
                    </p>
                  </div>
                </div>
              </section>
            )}
            <section className="GDA__section" id="learn">
              <AmexGDALearnMore
                animationPlay={animationPlay}
                animationPlayed={animationPlayed}
                pageContentByLanguage={pageContentByLanguageLearnMore}
                printContent={printContent}
                sectionLearn={this.sectionLearn}
                matchMedia={matchMedia}
                baseRequestUrl={baseRequestUrl}
                animationState={ANIMATION_STATE}
              />
            </section>
            <section className="GDA__section" id="gdaeditorial">
              {blogDataArray?.length > 0
              && (
                <AmexGDAEditorial
                  editorials={pageContentByLanguage.editorials}
                  blogDataArray={blogDataArray}
                  gdaEditorialApi={gdaEditorialApi}
                  printContent={printContent}
                  showMore={pageContentByLanguage.showMoreEditiorials}
                  Analytics={Analytics}
                />
              )}

            </section>
            <section className="GDA__section" id="gdafeatured">
              {featuredRestaurantsList?.length > 0
              && (
                <AmexGDAFeatured
                  featured={pageContentByLanguage.featured}
                  restaurants={featuredRestaurantsList}
                  printContent={printContent}
                  hasOriginB2B={hasOriginB2B}
                  hideEvents={hideEvents}
                  dispatch={dispatch}
                  Analytics={Analytics}
                />
              )}
            </section>
            {!hideEvents && (
              <AmexEventsComponent
                baseRequestUrl={baseRequestUrl}
                contentData={dataOutput?.events_and_experiences}
                matchMedia={matchMedia}
                Analytics={Analytics}
                eventsAllData={eventsAndExperiencesData}
                getEventComponentStatus={(status) => this.getComponentStatus('eventComponentStatus', status)}
                componentCallback={this.componentCallback}
              />
            )}

            {Object.keys(chefData)?.length !== 0 && (
              <section className="GDA__section" id="chef">
                <AmexGDAChef
                  baseRequestUrl={baseRequestUrl}
                  chefData={chefData}
                  printContent={printContent}
                />
              </section>
            )}
            {!hideFAQs && (
              <AmexFAQs
                faqsConfig={pageContentByLanguage?.faqs}
                eventAnalytics={Analytics.event}
                printContent={printContent}
              />
            )}
            <AmexTerms
              baseRequestUrl={baseRequestUrl}
              hash={hash}
              termsConfig={pageContentByLanguage?.terms}
              userLanguage={userBrowserLang}
              deepLink="global-dining-access-terms"
              Analytics={Analytics}
            />
            <AmexGDAFooter
              scrollTo={this.setScrollForDirMenu}
              footer={pageContentByLanguage.footer}
              amexFooterImg={pageContentByLanguage.amexFooterImg}
              baseRequestUrl={baseRequestUrl}
              androidAppLink={pageContentByLanguage.androidAppLink}
              iOsAppLink={pageContentByLanguage.iOsAppLink}
              printContent={printContent}
              hasOriginB2B={hasOriginB2B}
              Analytics={Analytics}
            />
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  const {
    bySlug: locationBySlug,
  } = state.resyLocations;

  const {
    selectedCoreISODate, selectedCoreSeats, selectedCoreTime,
  } = state.resyCore;

  return {
    locationBySlug,
    selectedCoreISODate,
    selectedCoreSeats,
    selectedCoreTime,
    venues: state?.collections?.venues?.marketing,
    isUserLoggedInAsGDA: selectIsGlobalDiningAccess(state),
    isAuthenticated: selectIsAuthenticated(state),
    isGoldUser: selectIsGoldCardMember(state),
    userLocation: state.ipdata,
  };
};

AmexGDA.displayName = 'AmexGDA';
export { AmexGDA as ComponentAmexGDAUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexGDA);
